import { render, staticRenderFns } from "./pages17.vue?vue&type=template&id=606c509d&scoped=true&"
import script from "./pages17.vue?vue&type=script&lang=js&"
export * from "./pages17.vue?vue&type=script&lang=js&"
import style0 from "./pages17.vue?vue&type=style&index=0&id=606c509d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c509d",
  null
  
)

export default component.exports